import { IResource } from "../i18n";

const translation_fr_fr: IResource = {
    header_title: "MEET | Entretiens sans friction",
    header_menu_api: "API",
    header_signup_text: "Inscription gratuite",
    header_signin_text: "se connecter",
    header_dashboard_text: "Mon tableau de bord",

    general_title_text: "Entretiens sans friction",
    general_cta_text_one: "Gagnez du temps, de l'argent et vos nerfs",
    general_cta_text_two: "lors de l'organisation et de la conduite",
    general_cta_text_three: "entretiens d'embauche à distance",
    general_cta_button: "Essayez maintenant gratuitement",
    general_cta_contact: "Contactez-nous : office@meet.rs",
    general_cta_consent_one: "Ce site utilise des cookies uniquement à des fins d'analyse et de personnalisation.",
    general_cta_consent_two: "En continuant à utiliser ce site, vous acceptez nos",
    general_tos_text: "Conditions d'utilisation",
    general_tos_tooltip: "Conditions d'utilisation de Vivani Meet",
    general_cookies_text: "Politique de cookies",
    general_cookies_tooltip: "Vivani Meet politique de cookies",
    general_privacy_text: "Politique de confidentialité",
    general_privacy_tooltip: "Vivani Meet politique de confidentialité",
    general_refund_text: "Politique de remboursement",
    general_refund_tooltip: "Vivani Meet politique de remboursement",

    usecase_title_head: "Conçu sur mesure pour les entretiens à distance",
    usecase_title_subhead: "Tout a été conçu en fonction des besoins d'entretien à distance que les recruteurs et les enquêteurs ont aujourd'hui",
    usecase_interviewer_title: "ACCOMMODANT POUR L'INTERVIEWER",
    usecase_interviewer_subtitle: "Bibliothèque de tâches",
    usecase_interviewer_body: "Configurez les tâches d'entretien à l'avance et profitez de l'entretien",
    usecase_interviewer_learnmore: "En savoir plus ",
    usecase_interviewer_imgalt: "Entretien sur le tableau blanc",
    usecase_collaboration_title: "TRAVAILLER ENSEMBLE",
    usecase_collaboration_subtitle: "Conçu pour la collaboration",
    usecase_collaboration_body_one: "Appeler, coder, dessiner, écrire ...",
    usecase_collaboration_body_two: "Tous ensemble, tous en même temps.",
    usecase_collaboration_learnmore: "En savoir plus ",
    usecase_collaboration_imgalt: "Entretien sur tableau blanc",    
    usecase_recruiter_title: "AISÉ POUR LE RECRUTEUR",
    usecase_recruiter_subtitle: "Faire votre travail pour vous",
    usecase_recruiter_body: "Planification automatique, prise de notes, rappels aux participants, collecte de commentaires...",
    usecase_recruiter_learnmore: "En savoir plus ",
    usecase_recruiter_imgalt: "Entretien sur le tableau blanc",    
    usecase_call_title: "APPEL VIDÉO DE GROUPE FULL HD",
    usecase_call_subtitle: "Avec enregistrement et transcription",
    usecase_call_body_one: "Zéro plugins, applications, installations",
    usecase_call_body_two: "Cela fonctionne uniquement sur les navigateurs modernes!",
    usecase_call_learnmore: "En savoir plus",
    usecase_call_imgalt: "Entretien sur le tableau blanc",     

    footer_email_text: "Contactez-nous",

    signout_menu_text: "Se déconnecter",
    me_menu_text: "Mes réunions",

    help_menu_text: "Aide",

    cta_nosignup_text : "Pas d’inscription ou de téléchargement requis.",

    // Change language
    language_selector_title: "Langue",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    general_cta_button_quick: "ANIMER UNE RÉUNION",
    general_cta_text_all: "Gagnez du temps, de l'argent et vos nerfs lors de l'organisation et de la conduite entretiens d'embauche à distance",

    header_title_short: "Vivani Meet",
}

export default translation_fr_fr;